module.exports = __webpack_public_path__ + "media/images/pic/how_we_teach-6dcf04131548bd0c954abf6603276702.svg";